import React from 'react';
import type { GraphicsQuality, MenuLanguage } from './types.js';

export function GraphicsSettings({ language, quality, showFps, showPing, reduceShake, onChange }: {
  language: MenuLanguage; quality: GraphicsQuality; showFps: boolean; showPing: boolean; reduceShake: boolean;
  onChange: (patch: Partial<{ quality: GraphicsQuality; showFps: boolean; showPing: boolean; reduceShake: boolean }>) => void;
}) {
  const es = language === 'es';
  const tr = (s: string, e: string, f: string) => es ? s : language === 'fr' ? f : e;
  return <section className="menu-setting-group">
    <label className="menu-setting"><span>{tr('Calidad gráfica', 'Graphics quality', 'Qualité graphique')}</span>
      <select value={quality} onChange={(event) => onChange({ quality: event.target.value as GraphicsQuality })}>
        <option value="auto">{tr('Automática', 'Automatic', 'Automatique')}</option>
        <option value="low">{tr('Baja', 'Low', 'Faible')}</option>
        <option value="medium">{tr('Media', 'Medium', 'Moyenne')}</option>
        <option value="high">{tr('Alta', 'High', 'Élevée')}</option>
      </select>
    </label>
    <label className="menu-check"><input type="checkbox" checked={showFps}
      onChange={(e) => onChange({ showFps: e.target.checked })} /> {tr('Mostrar FPS', 'Show FPS', 'Afficher les FPS')}</label>
    <label className="menu-check"><input type="checkbox" checked={showPing}
      onChange={(e) => onChange({ showPing: e.target.checked })} /> {tr('Mostrar ping', 'Show ping', 'Afficher le ping')}</label>
    <label className="menu-check"><input type="checkbox" checked={reduceShake}
      onChange={(e) => onChange({ reduceShake: e.target.checked })} /> {tr('Reducir sacudidas de cámara', 'Reduce camera shake', 'Réduire les secousses de caméra')}</label>
  </section>;
}
